export default __webpack_public_path__ + "6c741c32f964c3451c81ab8b3b5ebadc.png";